import { Component } from "@angular/core"
import { CardMetaComponent } from "../card-meta.component"

@Component({
    selector: "app-ymal-card-meta",
    templateUrl: "./ymal-card-meta.component.html",
    styleUrls: ["./ymal-card-meta.component.less"],
})
export class YmalCardMetaComponent extends CardMetaComponent {}
